module.exports = __webpack_public_path__ + "img/BHT_Logo.1cd95475.png";